import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { layout, breakpoint } from '~/theme';

const Container = styled.div`
    margin: 0 auto;
    width: 100%;
    max-width: ${({ maxWidth }) => layout[maxWidth] ?? layout.containerWidth};
    padding: 0 ${layout.gutter};

    @media (min-width: ${breakpoint.desktop}) {
        padding: 0 ${layout.largeGutter};
    }

    @media (min-width: ${breakpoint.largeDesktop}) {
        max-width: ${({ maxWidth }) =>
            layout[maxWidth] ?? layout.containerWidthLg};
    }
`;

Container.propTypes = {
    maxWidth: PropTypes.string
};

export default Container;
